<template>
  <div id="app">

    <v-fade-transition mode="out-in">
      <router-view/>
    </v-fade-transition>

    <the-notification>
    </the-notification>

  </div>
</template>

<script>
import VFadeTransition from '@/components/transitions/VFadeTransition'
import TheNotification from '@/components/common/TheNotification'

export default {
  components: { VFadeTransition, TheNotification }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "~bulma/sass/components/dropdown";
@import "~bulma/sass/form/_all.sass";
@import "~buefy/src/scss/components/_datepicker";
@import "~buefy/src/scss/components/_timepicker";
@import "~buefy/src/scss/components/_dropdown";
@import "@/styles/app.scss";
</style>
